import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'

import systemConfig from './modules/config'
import user from './modules/user'
import permission from './modules/permission'
import systemDict from './modules/dict'
import webSocket from './modules/socket'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  modules: {
    systemConfig,
    user,
    permission,
    systemDict,
    webSocket
  },
  actions: {
  },
  getters
})
